import React, { FC, ReactNode } from "react";
import Box from "@mui/material/Box";
import { tokens } from "../../styles/tokens";

export interface SurfaceCardProps {
  children: ReactNode;
  /** Adds hover lift. Use for cards that are themselves a link or button. */
  interactive?: boolean;
  sx?: object;
}

/**
 * The site's content card: white, hairline border, 16px radius, 24px padding,
 * and deliberately no resting shadow.
 */
const SurfaceCard: FC<SurfaceCardProps> = ({ children, interactive, sx }) => (
  <Box
    sx={{
      bgcolor: "background.paper",
      border: `1px solid ${tokens.color.hairline}`,
      borderRadius: `${tokens.radius.card}px`,
      p: `${tokens.space.cardPadding}px`,
      height: "100%",
      display: "flex",
      flexDirection: "column",
      ...(interactive && {
        transition: "all 0.3s",
        "&:hover": {
          boxShadow: tokens.shadow.md,
          transform: "translateY(-2px)",
        },
      }),
      ...sx,
    }}
  >
    {children}
  </Box>
);

export default SurfaceCard;
